import ProductShadowBase from "../productShadowBase";
import HouseholderEntry from "./Entry";

export default class HouseholderEntryElement extends ProductShadowBase {
  connectedCallback() {
    this.loadAndRender(() => (
      <HouseholderEntry
        backendHost={this.backendHost ?? undefined}
        appPathPrefix={this.appPathPrefix ?? undefined}
        skipCart={this.skipCart}
        channel={this.channel ?? undefined}
        language={this.language ?? undefined}
      />
    ));
  }
}
